module.exports = "../dist/frontend/icons/ui/in.svg?2dd4211b9e9d92e8a2a4f76c57aec9c8";